import {getImagePathWithHash} from '@utils/load_images';

/* General utility Javascript helpers used across site. */

// Handles showing or hiding tooltip text.
const handleToolTipShow = function (popUp, showToolTip) {
  return function () {
    if (showToolTip === undefined) {
      popUp.classList.toggle('hidden');
    } else if (showToolTip) {
      popUp.classList.remove('hidden');
    } else {
      popUp.classList.add('hidden');
    }
    const popUpBounds = popUp.getBoundingClientRect();
    const popUpArrow = popUp.querySelector('div:last-child');
    // Ensure the left side of popup is contained within the viewport.
    if (popUpBounds.left < 0) {
      popUp.style.left = `${-122 - popUpBounds.left}px`;
      popUpArrow.style.left = `${122 + popUpBounds.left}px`;
    }
    // Ensure the right side of popup is contained within the viewport.
    const rightSideOverflow = window.outerWidth - popUpBounds.right - 20;
    if (rightSideOverflow < 0) {
      popUp.style.left = `${-122 + rightSideOverflow}px`;
      popUpArrow.style.left = `${122 - rightSideOverflow}px`;
    }

    popUp.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  };
};

// Add tool tip interactivity to DOM elements with tooltip class.
const toolTips = document.querySelectorAll('.tooltip');
toolTips.forEach((toolTip) => {
  const toolText = toolTip.innerHTML;
  toolTip.innerHTML = '';
  const popUp = document.createElement('div');
  popUp.className = 'tooltip-popup hidden';
  const popUpText = document.createElement('div');
  popUpText.innerHTML = toolText;
  popUp.appendChild(popUpText);
  popUp.appendChild(document.createElement('div'));
  const questionIconSpan = document.createElement('span');
  /* eslint-disable max-len */
  const questionIcon =
    '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#003e51" width="48px" height="48px"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/></svg>';
  questionIconSpan.innerHTML = questionIcon;
  toolTip.appendChild(questionIconSpan);
  toolTip.appendChild(popUp);
  toolTip.style.display = 'inline-block';
  questionIconSpan.addEventListener('mouseover', handleToolTipShow(popUp, true), false);
  questionIconSpan.addEventListener('mouseout', handleToolTipShow(popUp, false), false);
});

// Add password input visibility toggle
const iconButtons = document.querySelectorAll('.visibility-icon-button');
if (iconButtons) {
  iconButtons.forEach((iconButton) => {
    iconButton.onclick = function (event) {
      event.preventDefault();
      const passwordInput = document.getElementById(event.target.dataset.toggleId);
      if (passwordInput) {
        passwordInput.type = passwordInput.type.includes('password') ? 'text' : 'password';
        // The event can come from the button or img element, but we only want the img to update it
        const icon = event.target.tagName === 'IMG' ? event.target : event.target.children[0];
        if (icon) {
          icon.src = icon.src.includes('visibility_off')
            ? getImagePathWithHash('icons/visibility_on.svg')
            : getImagePathWithHash('icons/visibility_off.svg');
        }
      }
    };
  });
}
